import constants from './constants';
import Configuration from '../modules/configuration';

const { DEFAULT_LOCALE } = constants;

const getLocaleFromPathname = (pathname) => {
  const config = Configuration.get();
  const baseLanguageCodes = config.getBaseLanguageCodes();
  const pathParts = pathname.split('/');

  return baseLanguageCodes.includes(pathParts[1]) ? pathParts[1] : DEFAULT_LOCALE;
};

export default getLocaleFromPathname;
